import { render } from "./MasterDataTablePermissionForm.vue?vue&type=template&id=1eeb7ab8&ts=true"
import script from "./MasterDataTablePermissionForm.vue?vue&type=script&lang=ts"
export * from "./MasterDataTablePermissionForm.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__